module.exports = __webpack_public_path__ + "img/feature2.83728ae1.png";